import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import InputField, {
    INPUT_FIELD_SIZES
} from "components/DesignComponents/InputField";

import { TextFieldProps } from "../types";

const TextField = ({
    timeZoneExplanatory,
    tooltipProps,
    ...restProps
}: TextFieldProps) => {
    const { textPlaceholder } = colors;

    const { error, helperText, InputProps, placeholder, value } = restProps;

    const isValuePresent = !!value && value !== placeholder;

    const isTimeZoneExplanatory =
        timeZoneExplanatory && isValuePresent && !error;

    const isReadOnly = InputProps?.readOnly;

    return (
        <div
            css={css({
                position: "relative"
            })}
        >
            <InputField
                {...restProps}
                tooltipTitle={tooltipProps?.title}
                disableInteractiveTooltip={tooltipProps?.isInteractiveDisabled}
                slotProps={{
                    input: {
                        ...InputProps
                    }
                }}
                fullWidth
                size={INPUT_FIELD_SIZES.Medium}
                readOnly={InputProps.readOnly}
                errorText={helperText}
                customStyle={{
                    "& .MuiInputAdornment-root": {
                        height: "0px",
                        margin: "0 8px 0 0",

                        "& .MuiIconButton-root": {
                            margin: "0 -8px"
                        }
                    },

                    "& .MuiInputAdornment-root:nth-of-type(1)": {
                        order: isValuePresent && !isReadOnly ? 3 : 1
                    },

                    "& .MuiInputAdornment-root:nth-of-type(2)": {
                        order: 1
                    },

                    "& .MuiOutlinedInput-input": {
                        order: 2
                    }
                }}
            />

            {isTimeZoneExplanatory && (
                <span
                    css={css({
                        position: "absolute",
                        top: "0",
                        left: "128px",
                        display: "flex",
                        alignItems: "center",
                        color: textPlaceholder,
                        fontSize: "14px",
                        fontWeight: "500",
                        lineHeight: "20px",
                        letterSpacing: "0.1px",
                        padding: "12px 0"
                    })}
                >
                    {timeZoneExplanatory}
                </span>
            )}
        </div>
    );
};

export default TextField;
